import validateRegex from "./regex"

export default function validateAmount(value) {
  return validateRegex(value, /^\d+[\.,]?\d{0,2}$/)
}